import React, { useState } from "react";
import styles from "./parent-details.module.css";
import ParentGuardianInfo from "./components/parent-guardian-info/parent-guardian-info";
import CustomButton from "../../../../../../common/custom-button/custom-button";
import SVGIcon from "../../../../../../constants/SVGIcon";
import { toast } from "react-toastify";
import AddEditParent from "./components/add-edit-parent/add-edit-parent";
import { resendCredentialsParents } from "../../../../../../services/student";

const ParentDetails = ({ details, setTriggerRefetch }) => {
  const [showModal, setShowModal] = useState(false);
  const [editParentData, setEditParentData] = useState(null);

  const onCloseAddEdit = () => {
    setTriggerRefetch((prev) => prev + 1);
    setShowModal(false);
  };

  const handleEditDetails = (data) => {
    setEditParentData(data);
    setShowModal(true);
  };

  const onClickAddParent = () => {
    setEditParentData(null);
    setShowModal(true);
  };
  const handleResendAllCredentials = async () => {
    try {
      await resendCredentialsParents({ parent_id: "" });
      toast.success("ResendAll is Successful");
    } catch (err) {
      toast.success("Error in ResendingAll Credentials");
    } finally {
    }
  };
  return (
    <div className={styles.details}>
      <div className={styles.head_button}>
        <CustomButton
          title="Resend All Credentials"
          size="large"
          onClick={handleResendAllCredentials}
        />
        <CustomButton
          title="Add Parent"
          size="large"
          icon={
            <SVGIcon
              name="add-icon"
              width="24"
              height="24"
              className="anticon"
              stroke="#FFF"
            />
          }
          onClick={onClickAddParent}
        />
      </div>
      <div className={styles.parent_details}>
        {Array.isArray(details?.parents) &&
          details?.parents?.map((e, index) => (
            <ParentGuardianInfo
              data={e}
              title={`Parent ${index + 1} Information`}
              full_name={e?.full_name ?? "-"}
              occupation={e?.occupation ?? "-"}
              phone_number={e?.phone_number ?? "-"}
              relationship={e?.parent_type ?? "-"}
              address={e?.address ?? "-"}
              email={e?.email ?? "-"}
              handleEditDetails={handleEditDetails}
              parentId={e?.id ?? "-"}
              reg_no={e?.user_name ?? "-"}
            />
          ))}
      </div>
      <AddEditParent
        onClose={onCloseAddEdit}
        open={showModal}
        editParentData={editParentData}
        studentId={details?.id}
      />
    </div>
  );
};

export default ParentDetails;
